import React from 'react';
import PropTypes from 'prop-types';

import {
  MenuList,
  MenuListItem,
  SVGIcon,
} from '@pearsontechnology/aero-components';

import { getIcon } from 'Workspace/helpers';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import pluginTypes, { otherMenuItems } from 'constants/pluginTypes';

import messages from './messages';
import { Menu, MenuListItemText } from './styles';

const menuPluginList = [
  pluginTypes.COURSE,
  pluginTypes.LESSON,
];

const AddProjectContentMenu = ({ openModalSelector, isImportEpubEnabled, isCornucopiaPhaseOneEnabled }) => {
  const menuList = [...menuPluginList];
  
  if (isCornucopiaPhaseOneEnabled) {
    menuList.push(pluginTypes.ETEXT);
  }
  if (isImportEpubEnabled) {
    menuList.push(otherMenuItems.IMPORT);
  }
  return (
    <Menu>
      <MenuList>
        {menuList.map((menuItemType) => (
          <MenuListItem
            key={menuItemType}
            onClick={() => openModalSelector(menuItemType)}
          >
            <SVGIcon
              icon={getIcon(menuItemType)}
              viewBox="0 0 24 24"
            />
            <MenuListItemText>
              {intl.formatMessage(messages[menuItemType])}
            </MenuListItemText>
          </MenuListItem>
        ))}
      </MenuList>
    </Menu>
  );
};

AddProjectContentMenu.propTypes = {
  openModalSelector: PropTypes.func.isRequired,
  isImportEpubEnabled: PropTypes.bool,
};

export default AddProjectContentMenu;
